import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="network-header">
      <div className="container">
        <nav className="nav-wrapper">
          <Link to="/" className="network-logo">
            <img src="/logo.jpg" alt="Nessenius Logo" className="logo-image" />
            <span className="logo-text">Nessenius Garten & Landschaftsbau</span>
          </Link>
          
          <button className="mobile-menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          
          <div className={`network-nav ${isMenuOpen ? 'open' : ''}`}>
            <Link to="/" className="network-nav-link" onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>
            <Link to="/leistungen" className="network-nav-link" onClick={() => setIsMenuOpen(false)}>
              Leistungen
            </Link>
            <Link to="/projekte" className="network-nav-link" onClick={() => setIsMenuOpen(false)}>
              Projekte
            </Link>
            <Link to="/ueber-uns" className="network-nav-link" onClick={() => setIsMenuOpen(false)}>
              Über uns
            </Link>
            <Link to="/bewertungen" className="network-nav-link" onClick={() => setIsMenuOpen(false)}>
              Bewertungen
            </Link>
            <Link to="/kontakt" className="network-nav-link" onClick={() => setIsMenuOpen(false)}>
              Kontakt
            </Link>
            <a href="tel:+4917655669090" className="btn-primary nav-cta">
              <Phone size={18} style={{ marginRight: '8px', display: 'inline-block', verticalAlign: 'middle' }} />
              Anrufen
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
